import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from './tools/client';

const notificationsUrl = `${process.env.MYPREDITY_BASE_URI}/notifications`;

export default {
  async getNotifications(config) {
    return Client.get(notificationsUrl, config)
      .then((response) => {
        return response.data.items;
      })
      .catch(errorHandler);
  },

  async getCountNotifications() {
    const url = `${notificationsUrl}/unread`;
    return Client.get(url)
      .then((response) => response.data.items)
      .catch(errorHandler);
  },

  async checkNotifications(id, body = {}) {
    const url = `${notificationsUrl}/${id}`;
    return Client.put(url, body)
      .then((response) => response.data)
      .catch(errorHandler);
  },
};
